import { render, staticRenderFns } from "./HitsTableView.vue?vue&type=template&id=53dff5ad&"
import script from "./HitsTableView.vue?vue&type=script&lang=js&"
export * from "./HitsTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports